const module = {
  config: {
    name: "kas",
    svg: "../static/img/icon/menu/wallet-fill.svg",
    desc: "Berisi modul riwayat saldo kas perpustakaan",
    layout: true
  },
  routes: [
    // Kas
    {
      name: "Kas Perpus",
      icon: "ri-record-circle-fill",
      path: "/kas-perpus",
      component: () => import("./finance.vue"),
      separator: "Default"
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/finance/_index.js